var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93449 9.58926L0.782016 1.6359C0.260423 0.960934 0.892 0.0947266 1.94352 0.0947266L14.2485 0.0947266C15.2983 0.0947266 15.9316 0.959684 15.4083 1.6359L9.25583 9.58926C9.13897 9.7428 8.97006 9.87043 8.76622 9.9592C8.56238 10.048 8.33086 10.0947 8.09516 10.0947C7.85945 10.0947 7.62794 10.048 7.4241 9.9592C7.22026 9.87043 7.05134 9.7428 6.93449 9.58926Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.97da736192c22e4ce6cc11fc634bab50.svg";
export { ForwardRef as ReactComponent };